import { message } from 'antd';
import { I18n } from 'react-redux-i18n';
import { addLoading, removeLoading } from './loading';

import MedicalAppointmentRequests from '../../api/medical-appointment';

export const ACTION_SAVE_ATTACHMENT = 'attachment:ACTION_SAVE_ATTACHMENT';
export const SET_ATTACHMENT_FILES = 'attachment:SET_ATTACHMENT_FILES';

export const setAttachmentFiles = (files) => (dispatch) => {
  dispatch({
    type: SET_ATTACHMENT_FILES,
    payload: files,
  });
};

export const saveAttachmentAppointment = (data) => async (dispatch) => {
  dispatch(addLoading);

  try {
    const result = await MedicalAppointmentRequests.saveAttachmentAppointment(data);
    dispatch({
      type: ACTION_SAVE_ATTACHMENT,
      payload: result
    });

    return result;
  } catch (err) {
    const errors = I18n.t('ERRORS');

    if (err && err.message && errors[err.message] !== undefined) {
      message.error(`${errors[err.message]}`);
    } else if (
      err &&
      err.response &&
      err.response.response &&
      err.response.response.error &&
      errors[err.response.response.error] !== undefined
    ) {
      message.error(`${errors[err.response.response.error]}`);
    } else {
      message.error(errors.genericError);
    }
  } finally {
    dispatch(removeLoading);
  }
};